import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  map,
  tap,
  switchMap,
  distinctUntilChanged,
  first
} from 'rxjs/operators';
import { AuthService } from '../../../../services';
import { of, Subscription } from 'rxjs';
import { isIframe } from '../../../../functions';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavBarComponent implements OnInit {
  collapse: boolean = true;
  survey_id: string;
  subscriptions: Subscription[] = [];
  isIframe: boolean;
  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.route.params
        .pipe(
          map(params => params.survey_id),
          distinctUntilChanged(),
          tap(survey_id => (this.survey_id = survey_id)),
          switchMap(survey_id => {
            if (!survey_id) return of(null);
            return this.auth.idTokenResult.pipe(first());
          })
        )
        .subscribe(() => {
          this.cdRef.detectChanges();
        })
    );
    this.isIframe = isIframe();
    this.cdRef.detectChanges();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  getSurveyScope(type): string | boolean {
    return this.auth.getSurveyScope(type);
  }
}
